import Alpine from "alpinejs";

Alpine.data('lifecountdown', () => ({
    days: 0,
    hours: 0,
    hoursInclDays: 0,
    minutes: 0,
    seconds: 0,
    targetTimestamp: parseInt(document.querySelector('.c-countdown-list').getAttribute('data-timestamp'), 10),

    startCountdown() {
        this.updateCountdown();
        setInterval(() => this.updateCountdown(), 1000);
    },

    updateCountdown() {
        const now = Math.floor(Date.now() / 1000);
        const timeLeft = this.targetTimestamp - now;

        if (timeLeft <= 0) {
            this.days = 0;
            this.hours = 0;
            this.hoursInclDays = 0;
            this.minutes = 0;
            this.seconds = 0;
            return;
        }

        this.days = Math.floor(timeLeft / (60 * 60 * 24));
        this.hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
        this.hoursInclDays = this.days * 24 + this.hours;
        this.minutes = Math.floor((timeLeft % (60 * 60)) / 60);
        this.seconds = timeLeft % 60;
    },

    formatMinutes() {
        return this.minutes < 10 ? '0' + this.minutes : this.minutes;
    },

    formatSeconds() {
        return this.seconds < 10 ? '0' + this.seconds : this.seconds;
    }
}));
